import type { shd } from '@shd/jslib/models';

export interface CameraSelectorProps {
  capture: shd.TeamCapture;
  status: CaptureStatus;
  teamId: string;
  teamName: string;
  isSelected?: boolean;
  onClick?: (capture: shd.TeamCapture) => void;
}

export enum CaptureEquipmentName {
  GOPRO = 'GoPro',
  MEVO = 'Mevo',
  MEVO_MULTI = 'Mevo Multicam',
  MEVO_SINGLE = 'Mevo Single',
  RTMP = 'RTMP',
  SIDELINE_APP = 'SidelineHD App',
  SMARTPHONE = 'Smart phone / Tablet',
  SMARTPHONE_LEGACY = 'Smart phone',
}

export enum CaptureLogoUrl {
  GOPRO = '/capture_icons/gopro.png',
  MEVO = '/capture_icons/mevo.png',
  MEVO_MULTI = '/capture_icons/mevo_multi.png',
  MEVO_SINGLE = '/capture_icons/mevo_single.png',
  RTMP = '/capture_icons/rtmp.png',
  SMARTPHONE = '/logo192.png',
  SMARTPHONE_LEGACY = '/capture_icons/larix.png',
}

export enum CaptureStatus {
  Ready = 'ready',
  Disabled = 'disabled',
  Live = 'live',
  TeamLive = 'team_live',
  OtherTeam = 'other_team',
}

export interface CameraStatusProps {
  status: CaptureStatus;
  targetTeamName: string;
  teamName: string;
}
